<template>
  <a-card :title="$dt(bulletinData,'NOTICE_NAME')">
    <div class="ql-editor" v-html="$dt(bulletinData,'CONTENT')"></div>
  </a-card>
</template>

<script>
export default {
  name: "bulletinDetail",
  data(){
    return{
      bulletinData: {}
    }
  },
  methods:{
    getBulletinData(){
      this.$h5Api({
        type: '1001',
        data: [this.$dotNetUtil.commonQueryJson('GM_NOTICE', {NOTICE_ID: this.$route.query.NOTICE_ID},'1')],
      }).then(({data}) => {
        this.bulletinData = data?.DATA_LIST?.[0];
      })
    }
  },
  created() {
    this.getBulletinData();
  }
}
</script>

<style scoped>

</style>